export const RequestIncident = ({ formContentItem }) => {
  return (
    <>
      {formContentItem.SuWork()}
      {formContentItem.Symptoms}
    </>
  );
};

export default RequestIncident;
